import { Injectable } from "@angular/core"
import { ErrorStreamChange } from "../models/$error.model"
import { DBEventPropertyWhiteList, getEventDatesData, JoiEventWithDeprecatedProps, BaseJoiPage, JoiDataPage, createNewEventPageGenerator, baseJoiPageKeys, PostMessageData, UpdateMessageCutoffData } from "../../../globals/store/events.data"
import { eventsFeature, JoiEvent } from "../store/events.era"
import { LogService } from "./log.service"
import { select, Store } from "@ngrx/store"
import { getEventSizeAsPercent, subTilDestroy } from './../helpers/helpers';
import * as firebase from 'firebase/app';
import { deleteFromPages, updateInPages } from "globals/store/pages.data"
import { Dictionary } from "@ngrx/entity"
import { Entity } from "globals/store/entity.data"
import { environment } from "../../environments/environment"
import { Subject } from "rxjs"
import { JoiAccount } from "globals/store/accounts.data"
import { take } from "rxjs"
import { HttpClient } from "@angular/common/http"
import { cleanEntry } from "../helpers/helpers"
import { collection, deleteField, doc, Firestore, runTransaction, Transaction, updateDoc } from "@angular/fire/firestore"
import { accountsFeature } from "../store/accounts.era"
import { jsonCopyObject } from "globals/helpers/helpers"

// // This service helps get rid of the circular dependency warnings of services that both call each other (or that both call each other through other intermediary files)
@Injectable({ providedIn: 'root' })
export class DecircularService {

  private _file = 'decircular.service.ts'
  $destroy: Subject<boolean> = new Subject()
  account: JoiAccount
  accounts: Dictionary<JoiAccount>
  event: JoiEvent
  events: Dictionary<JoiEvent>
   readonly api = `${environment.functionsURL}api/app`
//   //
   constructor(
     private log: LogService,
     public store: Store, 
     private db: Firestore,
//     private afs:AngularFirestore,
     private http: HttpClient,
   ) {
    subTilDestroy(this, select(accountsFeature.selectAccount), 'account')
    subTilDestroy(this, select(accountsFeature.selectEntities), 'accounts')

    subTilDestroy(this, select(eventsFeature.selectEvent), 'event')
    subTilDestroy(this, select(eventsFeature.selectEntities), 'events')
   }

  private updateEventPages(updates: Dictionary<Partial<JoiDataPage>>, transaction: Transaction) {
    Object.entries(updates).forEach(([pageId, update]) => 
      transaction.update(doc(this.db, `eventPages/${pageId}`), update)
    )
  } 

  
  
  async deleteFromEventPages(type: keyof BaseJoiPage, ids: string[], eventPages: JoiDataPage[]) {
    const updates = deleteFromPages(eventPages, type, ids, deleteField)
    console.log({ updatesWithDeletions: updates })
    await runTransaction(this.db, async (transaction) => {
      this.updateEventPages(updates, transaction)
    })
  }

  accountCanBeUpdatedCheck(eventId: string) {
console.log({ eventId, event: this.event, events: this.events })
    const outsideEvent = !this.event
    const event: JoiEvent = outsideEvent ? this.events[eventId] : this.event
    const account: JoiAccount = outsideEvent ? this.accounts[event.accountId] : this.account
  
    const accountStatus = account?.docket?.status
    console.log({ outsideEvent, event, account, accountStatus })
    if (!accountStatus) return true // hack more than anything else

    if (['active', 'fresh', 'incomplete', 'custom', 'trial', 'beta'].includes(accountStatus)) return true
    console.log({ accountStatus })
    this.log.error({
      file:this._file,
      function:'updateEvent',
      data: { eventId, accountId: this.account?.id || 'Missing Account', accountStatus },
      error: new Error,
      message: `The event cannot be updated because the account status is: ${accountStatus}`
    })
    return false
  }

  async saveEventPageEntities(type: keyof BaseJoiPage, entities: Entity[], eventId: string, accountId: string, eventPages: JoiDataPage[]) {
    console.log({ type, entities, eventId, accountId, eventPages })
    if (!this.accountCanBeUpdatedCheck(eventId)) return
    const theEntities = jsonCopyObject(entities);
    theEntities.forEach(e => e.dateModified = new Date().getTime())
    const { changes, newPages } = updateInPages<JoiDataPage, typeof type, Entity>(eventPages, type, theEntities, createNewEventPageGenerator(eventId, accountId), environment.MAX_PAGE_SIZE, deleteField)
    console.log({ changes, newPages })
    await runTransaction(this.db, async (transaction) => {
      newPages.forEach(page => { // should just be one new page here at most, of course, but updateInPages is more general than that
        console.log({ page })
        const ref = doc(collection(this.db, "eventPages"))
        page.id = ref.id
        console.log({ newPage: page })
        transaction.set(ref, page)
      })
      this.updateEventPages(changes, transaction)
    })
  }

  public async sendMessage(data: PostMessageData) {
    console.log(data)
    const url = `${this.api}/post-message`
    try {
      await this.http.post(url, data).pipe(take(1)).toPromise()
    } catch (error) {
      console.error(error)
    }
  }

  public async updateMessageCutoff(data: UpdateMessageCutoffData) {
    const url = `${this.api}/update-message-cutoff`
    try {
      await this.http.post(url, data).pipe(take(1)).toPromise()
    } catch (error) {
      console.error(error)
    }
  }

  async updateEvent(eventId:string, changes:Partial<JoiEventWithDeprecatedProps>, log_data:Partial<ErrorStreamChange> = {}) {   

    if (!this.accountCanBeUpdatedCheck(eventId)) return
    
    const partialEvent = cleanEntry(changes, DBEventPropertyWhiteList)
    const oldEvent = this.event || this.events[eventId]
    if (!!oldEvent) {
      const oldBaseEvent = { ...oldEvent } // shallow copy okay because all JoiPageProps are top level props
      baseJoiPageKeys.forEach(k => delete oldBaseEvent[k]) // now should really be the "old base event"

      const oldSize = getEventSizeAsPercent(oldBaseEvent)
      const event = { ...oldBaseEvent, ...partialEvent }
      const size = getEventSizeAsPercent(event)
      console.log({ eventId, partialEvent, oldBaseEvent, oldSize, event, size })
      if (size > 100 && size > oldSize) { // always allow shrinking event (if size < oldSize can still update)
        this.log.error({
          file:this._file,
          function:'updateEvent',
          data: null, // do NOT pass the eventId, changes, partial event like below.  This somehow causes the backend, or SOMETHING, to try again
          error: new Error,
          message: 'Event too large, cannot update the event',
          ...log_data
        })
        return
      }
    }
    try {
      updateDoc(doc(this.db, `events/${eventId}`), partialEvent)
    } catch(response) {
      this.log.error({
          file:this._file,
          function:'updateEvent',
          response,
          data: { eventId, changes, partialEvent },
          error: new Error,
          message: 'There was an error updating the event',
          ...log_data
      });
    }

  }



  saveEventDays(event:JoiEvent, date_arr:string[]) {
    const datesUpdate = getEventDatesData(event, date_arr)
    if (!datesUpdate) return
    this.updateEvent(event.eventId, datesUpdate)
  }

}
